<template>
  <v-container>
    <div v-if="loading" class="text-center">
      <v-progress-circular indeterminate color="primary" />
    </div>

    <div v-else>
      <router-view :testator="testator" :people-relations="peopleRelations" />
    </div>
  </v-container>
</template>

<script>
  import { TESTATOR_QUERY } from '../../constants/graphql/testators';
  import { getRelations } from '../../constants/js/people';

  export default {
    name: 'AssetsBase',
    data() {
      return {
        testator: {},
        loading: true,
        peopleRelations: {},
      };
    },
    apollo: {
      testator: {
        query: TESTATOR_QUERY,
        variables() {
          return {
            id: this.testatorId,
          };
        },
        result(response) {
          if (response.data && response.data.testator) {
            this.peopleRelations = getRelations(response.data.testator.people);
            this.loading = false;
          }
        },
      },
    },
  };
</script>
